import { Skeleton as AntSkeleton } from 'antd'
import type { ComponentProps } from 'react'

type AntSkeletonProps = ComponentProps<typeof AntSkeleton>

export interface AppSkeletonProps extends AntSkeletonProps {}

export const AppSkeleton = (props: AppSkeletonProps) => <AntSkeleton {...props} />

export const AppSkeletonButton = AntSkeleton.Button
export const AppSkeletonInput = AntSkeleton.Input
export const AppSkeletonImage = AntSkeleton.Image
export const AppSkeletonAvatar = AntSkeleton.Avatar
